import React, { Component } from 'react';
import { BreadCumb, DataTables, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },//0
    { title: "Num.Doc", value: true },//1
    { title: "Cliente", value: true },//2
    { title: "Nombre", value: true },//3
    { title: "Fecha Cont.", value: true },//4
    { title: "Cancelado", value: true },//5
    { title: "Facturas", value: true },//6
    { title: "Comentarios", value: true },//7
    { title: "Total", value: true },//8
    { title: "Observacion del Estado", value: true },//9
    { title: "Estado del documento", value: true },//10
    { title: "Docs Vencidos", value: false },//11
    { title: "Facturado", value: false },//12
    { title: "Pagado", value: false },//13
    { title: "Vencido", value: false }//14
]
class PaymentView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liPago");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
            docStatus: 'N',
        }
        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            employeeValue: newDate.employeeValue || '---',
            table: "ORCT",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            docStatus: newDate.docStatus || 'N',
        };

        enableSpinner(true);
        let paymentListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (paymentListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            let dataSerie = {
                docType: "24",
                docSubType: "--"
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesORCT ? user.U_FMB_ValidateSeriesORCT : "";

            if (!user || ValidateSeries == "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];

            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }



            let newDocumentsfilterSeries = [];

            paymentListResponse.data.map(document => {
                const match = newArraySeries.find(serie => document.SeriesCode == serie.Series);
                        if (match) {
                        newDocumentsfilterSeries.push(document);
                    }
            });

            if (newDate.docNumSearch && newDate.docNumSearch !== '--') { newDocumentsfilterSeries = paymentListResponse.data; }

            if (newDate.docStatus && newDate.docStatus !== '---') {
                newDocumentsfilterSeries = newDocumentsfilterSeries.filter(doc => {
                    const canceled = doc.Canceled === 'Y' || doc.Canceled === 'y' || doc.Canceled === true;
                    return newDate.docStatus === 'Y' ? canceled : !canceled;
                });
            }

            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        }

        // showAlert({type: 'error', message: paymentListResponse.message});

    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };


    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'PAGOS RECIBIDOS'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;PAGOS RECIBIDOS
                        </a>
                    </h2>
                    <DataTables headers={headers} view={"payment"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentView);